import { Grid, TextField } from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import MeditocModal from "../../../utils/MeditocModal";
import { useMotivoConsulta } from "../../../../context/MotivoConsultaContext";

export default function FormMotivoConsulta() {
    const {
        motivoConsultaSeleccionada,
        modalOpenFormMotivoConsulta,
        formMotivoConsulta,
        handleOpenFormMotivoConsulta,
        handleChangeFormMotivoConsulta,
        handleSubmitFormMotivoConsulta,
    } = useMotivoConsulta();

    const { txtNombre, txtNombreEng } = formMotivoConsulta;
    return (
        <MeditocModal
            title={
                motivoConsultaSeleccionada.iIdMotivoConsulta === 0
                    ? "Nuevo motivo de consulta"
                    : "Editar motivo de consulta"
            }
            okfunc={handleSubmitFormMotivoConsulta}
            setopen={handleOpenFormMotivoConsulta}
            open={modalOpenFormMotivoConsulta}
            okmessage="Guardar"
            size="small"
            form
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        name="txtNombre"
                        label={txtNombre.label}
                        required={txtNombre.required}
                        value={txtNombre.value}
                        error={txtNombre.error}
                        helperText={txtNombre.error && txtNombre.message}
                        onChange={handleChangeFormMotivoConsulta}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        autoFocus
                        inputProps={{
                            maxLength: 45,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtNombreEng"
                        label={txtNombreEng.label}
                        required={txtNombreEng.required}
                        value={txtNombreEng.value}
                        error={txtNombreEng.error}
                        helperText={txtNombreEng.error && txtNombreEng.message}
                        onChange={handleChangeFormMotivoConsulta}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        inputProps={{
                            maxLength: 45,
                        }}
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
